<template>
  <div class="all-ideas">
    <PreContentHeader :show-loading="!contentReady" :error-message="contentLoadError"></PreContentHeader>
    <transition name="fade">
      <div v-if="contentReady && contentLoadError === ''">
        <ContentHeader name="All ideas"></ContentHeader>
        <div class="alert alert-info">
          <h4 class="alert-heading">Filtered Search</h4>
          <hr>
          <div class="row">
            <div class="col-xl-6 mb-2">
              <label>Idea Category</label>
              <select v-model="ideaCategorySelect" v-on:change="loadIdeas()" class="form-control">
                <option>-- All --</option>
                <option v-for="category in ideaCategories" v-bind:key="category.id" :value="category.id">{{category.name}}</option>
              </select>
            </div>
            <div class="col-xl-6 mb-2">
              <label>Community</label>
              <select v-model="communityCategorySelect" v-on:change="loadIdeas()" class="form-control">
                <option>-- All --</option>
                <option v-for="category in communityCategories" v-bind:key="category.id" :value="category.id">{{category.name}}</option>
              </select>
            </div>
          </div>
        </div>
        <Ideas v-if="ideas.length > 0" :ideas="ideas"></Ideas>
        <span v-if="ideas.length === 0">
          No ideas have been submitted, <router-link to="/idea-challenges">view the Idea Challenges here</router-link> and submit an idea
        </span>
        <div class="row">
          <div class="col-sm-6 mt-3">
            <b-pagination size="md" :total-rows="totalPosts" v-model="currentPage" :per-page="itemsPerPage"></b-pagination>
          </div>
          <div class="col-sm-6 mt-3">
            <div class="items-per-page">
              <label for="itemsPerPage">Ideas per page: </label>
              <select v-model="itemsPerPage" id="itemsPerPage" v-on:change="loadIdeas()" class="form-control">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import WordpressRestAPI from '@/helpers/WordpressRestAPI.js'
import ContentHeader from '@/components/ContentHeader'
import Ideas from '@/components/Ideas'
import PreContentHeader from '@/components/PreContentHeader'
import { mapGetters } from 'vuex'
export default {
  components: {
    PreContentHeader,
    ContentHeader,
    Ideas
  },
  computed: {
    // mix the getters into computed with object spread operator
    ...mapGetters([
      'getUserCommunityIDstring',
      'getUserCommunityIDs'
    ])
  },
  data () {
    return {
      ideas: [],
      contentReady: false,
      contentLoadError: '',
      ideaCategories: [],
      ideaCategorySelect: '-- All --',
      communityCategories: [],
      communityCategorySelect: '-- All --',
      currentPage: 1,
      totalPosts: 0,
      itemsPerPage: 10
    }
  },
  created () {
    document.title = this.$route.name + ' - ThinkTank'
    WordpressRestAPI.getViewContent('idea_chalenge_category?per_page=100')
      .then(response => {
        this.ideaCategories = response.data
      })
      .catch(e => {
        console.error(e)
      })
    this.loadFilters()
    this.loadIdeas()
  },
  methods: {
    getAPiCallString: function () {
      if (!this.$store.getters.isAdmin && this.getUserCommunityIDstring !== undefined) {
        return 'community_categories=' + this.getUserCommunityIDstring
      } else {
        return ''
      }
    },
    generateSearchQuery: function () {
      if (this.ideaCategorySelect !== '-- All --' && this.communityCategorySelect === '-- All --') {
        return '?idea_chalenge_category=' + this.ideaCategorySelect + '&_embed'
      } else if (this.ideaCategorySelect === '-- All --' && this.communityCategorySelect !== '-- All --') {
        return '?community_categories=' + this.communityCategorySelect + '&_embed'
      } else if (this.ideaCategorySelect !== '-- All --' && this.communityCategorySelect !== '-- All --') {
        return '?idea_chalenge_category=' + this.ideaCategorySelect + '&community_categories=' + this.communityCategorySelect + '&_embed'
      } else {
        return '?_embed'
      }
    },
    loadFilters: function () {
      WordpressRestAPI.getViewContent('community_categories?per_page=5')
        .then(response => {
          this.communityCategories = response.data
          if (!this.$store.getters.isAdmin && this.getUserCommunityIDstring !== undefined) {
            this.communityCategories = this.communityCategories.filter(x => this.getUserCommunityIDs.includes(x.id))
          }
        })
        .catch(e => {
          console.error(e)
        })
    },
    loadIdeas: function () {
      this.contentReady = false
      WordpressRestAPI.getViewContent('idea' + this.generateSearchQuery() + '&page=' + this.currentPage + '&per_page=' + this.itemsPerPage)
        .then(response => {
          this.totalPosts = parseInt(response.headers['x-wp-total'])
          this.ideas = response.data
          if (!this.$store.getters.isAdmin && this.getUserCommunityIDstring !== undefined) {
            this.ideas = this.ideas.filter(x => x.community_categories.some(v => this.getUserCommunityIDs.includes(v)))
          }
          this.contentReady = true
        })
        .catch(e => {
          this.contentLoadError = 'Oops! We had a problem loading ideas. Please try again later.'
          console.error(e)
          this.contentReady = true
        })
    }
  },
  watch: {
    getUserCommunityIDstring (newDetails, oldDetails) {
      this.loadFilters()
      this.loadIdeas()
    },
    'currentPage' (newDetails, oldDetails) {
      this.loadIdeas()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/routes/AllIdeas.vue